import Resource from './Resource';

export default class ClassPageForum extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let forumType = '';
		if( options.type === 'course' ){
			forumType = 'forums';
		}

		if( options.type === 'group' ){
			forumType = 'student-group-forums';
		}

		if( options.type === 'student' ){
			forumType = 'student-forums';
		}

		let config = {
			route: `class-pages/:courseSectionGuid/${forumType}/:forumId`,
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
